import React from 'react';
import ComissaoFlexService from '../../../../lib/api/comissaoFlex/comissaoFlex';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ComissaoFlex extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarExcelParametrosComissaoFlex() {
		return ComissaoFlexService.obterExcel();
	}

	enviarParametrosEventGrid() {
		return ComissaoFlexService.enviarParametrosAoEventGrid();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.enviarParametrosEventGrid}
				baixarExcelParametros={this.baixarExcelParametrosComissaoFlex}
				enviarExcelParametros={ComissaoFlexService.comissaoFlexExcelPost}
				deletarExcelParametros={ComissaoFlexService.deletarExcelParametros}
				nomeDoArquivo='Comissao Flex'
			/>
		);
	}
}

export default ComissaoFlex;
